import {inject} from "aurelia-framework";
import {ChoiceLoader} from "../loader/choice-loader";

@inject(
    ChoiceLoader
)
export class AirportChoiceLoader {
    constructor(
        choiceLoader
    ) {
        this.choiceLoader = choiceLoader;
    }

    load(requestConditions = null, initialValues = null)
    {
        return this.choiceLoader.getChoices(
            {modelId: 'aviation/airport'},
            requestConditions,
            initialValues,
            "limit=10000"
        );
    }
}
